(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.documentElement;
    if (root.dataset.sizeChartController === 'true') return;
    root.dataset.sizeChartController = 'true';

    let activeModal = null;
    let opener = null;

    const onScroll = () => closeModal(false);

    function closeModal(restoreFocus = true) {
      if (!activeModal) return;
      activeModal.style.display = 'none';
      if (opener) opener.setAttribute('aria-expanded', 'false');
      window.removeEventListener('scroll', onScroll);
      const focusTarget = opener;
      activeModal = null;
      opener = null;
      if (restoreFocus && focusTarget) focusTarget.focus();
    }

    function openModal(trigger) {
      const id = trigger.getAttribute('aria-controls');
      const modal = id ? document.getElementById(id) : null;
      if (!modal) return;
      if (activeModal && activeModal !== modal) closeModal(false);
      activeModal = modal;
      opener = trigger;
      modal.style.display = 'block';
      trigger.setAttribute('aria-expanded', 'true');
      const closeButton = modal.querySelector('[data-size-chart-close]');
      if (closeButton) closeButton.focus();
      window.addEventListener('scroll', onScroll, { passive: true, once: true });
    }

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-size-chart-open]');
      if (trigger) {
        event.preventDefault();
        openModal(trigger);
        return;
      }

      if (event.target.closest('[data-size-chart-close]')) {
        closeModal();
        return;
      }

      if (activeModal && event.target === activeModal) closeModal();
    });

    document.addEventListener('keydown', (event) => {
      if (!activeModal) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }
      if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('[data-size-chart-close]')) {
        event.preventDefault();
        closeModal();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
